/* ══════════════════════════════════════════════════
   UnaLuka Smart Search v2.0 — 1790724199
   Misma UI original del tema Electro.
   Inteligencia bajo el capó: Predictive API + sinónimos + boosting.
   ══════════════════════════════════════════════════ */

var AT_AjaxSearch = (function($) {

  /* ── Config ── */
  var DEBOUNCE_MS = 250;
  var MIN_CHARS = 2;
  var MAX_RESULTS = 10;
  var API_TIMEOUT = 3000;

  /* ── Sinónimos — mapeo de intención ── */
  var SYNONYMS = {
    'celular':     ['smartphone','telefono','iphone','samsung','phone','movil'],
    'audifono':    ['audifonos','earbuds','headphones','earphones','airpods'],
    'audifonos':   ['audifono','earbuds','headphones','earphones','airpods'],
    'cargador':    ['charger','cable','carga','usb-c','lightning'],
    'parlante':    ['speaker','bocina','altavoz','bluetooth speaker','jbl'],
    'tablet':      ['ipad','tableta'],
    'laptop':      ['notebook','macbook','computadora','portatil'],
    'reloj':       ['watch','smartwatch','apple watch','garmin'],
    'consola':     ['playstation','ps5','xbox','nintendo','switch','gaming'],
    'tele':        ['television','televisor','tv','smart tv'],
    'television':  ['televisor','tv','smart tv','tele','led','qled','oled'],
    'televisor':   ['television','tv','smart tv','tele'],
    'camara':      ['camera','gopro','fotografia','webcam'],
    'perfume':     ['fragancia','colonia','cologne','fragrance','eau de'],
    'maquillaje':  ['makeup','cosmetico','cosmetics','beauty'],
    'crema':       ['cream','moisturizer','locion','hidratante'],
    'labial':      ['lipstick','lip gloss','lip'],
    'serum':       ['suero','tratamiento','skincare'],
    'protector':   ['sunscreen','spf','bloqueador','solar'],
    'zapatilla':   ['zapatillas','sneakers','shoes','tenis'],
    'zapatillas':  ['zapatilla','sneakers','shoes','tenis'],
    'cartera':     ['bolso','bag','handbag','purse','mochila'],
    'lentes':      ['gafas','sunglasses','anteojos'],
    'polo':        ['camiseta','t-shirt','shirt','playera'],
    'casaca':      ['chaqueta','jacket','hoodie','chamarra'],
    'pantalon':    ['pants','jeans','jogger','pantalones'],
    'ropa':        ['camiseta','polo','pantalon','casaca','buzo'],
    'licuadora':   ['blender','batidora'],
    'aspiradora':  ['vacuum','aspirador','robot aspirador'],
    'vitamina':    ['vitaminas','vitamin','suplemento','supplement'],
    'proteina':    ['protein','whey','suplemento'],
    'colageno':    ['collagen','colageno hidrolizado'],
    'juguete':     ['toy','juego','lego','juguetes'],
    'muneca':      ['doll','barbie'],
    'funda':       ['case','protector','cover','carcasa'],
    'mouse':       ['raton','logitech','gaming mouse'],
    'teclado':     ['keyboard','mecanico','gaming keyboard'],
    'impresora':   ['printer','epson','hp printer'],
    'disco':       ['ssd','hdd','almacenamiento','hard drive','usb'],
    'monitor':     ['pantalla','display','screen'],
    'router':      ['wifi','modem','red','mesh'],
    'drone':       ['dron','dji','quadcopter']
  };

  /* Queries genéricos donde la API falla — SIEMPRE expandir con sinónimos */
  var ALWAYS_EXPAND = ['ropa','vestimenta','clothing','electronica','tecnologia','belleza','deporte','deportes','hogar'];

  /* ── Corrección fonética — errores comunes en español LATAM ── */
  var PHONETIC = {
    /* ── Apple ── */
    'ifon':'iphone','ifone':'iphone','aifon':'iphone','aifone':'iphone','aiphone':'iphone',
    'iphon':'iphone','ipone':'iphone','ihpone':'iphone','iphoe':'iphone','ifonee':'iphone',
    'aipad':'ipad','aipod':'airpods','aipods':'airpods','airpod':'airpods','earpods':'airpods',
    'earpod':'airpods','airpos':'airpods','eirpods':'airpods',
    'macbuk':'macbook','makbook':'macbook','makbuk':'macbook','macbok':'macbook',
    'apel':'apple','aple':'apple','appel':'apple',
    /* ── Samsung ── */
    'samsun':'samsung','samsum':'samsung','sansung':'samsung','samsumg':'samsung','samsuny':'samsung',
    'sansun':'samsung','samgsung':'samsung','samsug':'samsung','galxy':'galaxy','galaxi':'galaxy',
    /* ── Otras marcas tech ── */
    'guawei':'huawei','juawei':'huawei','hawei':'huawei','huawey':'huawei','huwei':'huawei',
    'xiaome':'xiaomi','xiomi':'xiaomi','shaomi':'xiaomi','xaomi':'xiaomi','chiaomi':'xiaomi',
    'nique':'nike','naik':'nike','naike':'nike','niqui':'nike',
    'adiddas':'adidas','addidas':'adidas','adidass':'adidas',
    'puma':'puma','conbers':'converse','comberse':'converse',
    'logitec':'logitech','loyitech':'logitech',
    'jbl':'jbl','yebl':'jbl',
    'bose':'bose','bos':'bose',
    'dior':'dior','dyor':'dior',
    /* ── Categorías / genéricos ── */
    'selular':'celular','zelular':'celular','selular':'celular','celulr':'celular',
    'telefono':'telefono','celulares':'celular',
    'audifonos':'audifono','audifono':'audifono','audifo':'audifono','audifons':'audifono',
    'auriculares':'audifono','aurikulares':'audifono',
    'parlant':'parlante','parlnte':'parlante','vocina':'bocina','bosina':'bocina',
    'bafle':'parlante','baffle':'parlante',
    'relojes':'reloj','reloi':'reloj','smartwach':'smartwatch','smarwatch':'smartwatch',
    'esmarwach':'smartwatch','smarwach':'smartwatch',
    'televicion':'television','televisor':'television','telebision':'television','tele':'television',
    'cargdor':'cargador','cargdaor':'cargador',
    'portatil':'laptop','laptob':'laptop','notbook':'notebook','notebuk':'notebook',
    'tableta':'tablet','tablt':'tablet',
    'konsola':'consola','concola':'consola',
    'pleisteision':'playstation','pleistation':'playstation','playstetion':'playstation',
    'nintndo':'nintendo','nientendo':'nintendo',
    'ecsbox':'xbox','exbox':'xbox',
    /* ── Belleza / moda ── */
    'perfum':'perfume','parfum':'perfume','colonia':'perfume','frangancia':'fragancia',
    'fragansia':'fragancia','fragransia':'fragancia',
    'maquiyaje':'maquillaje','maquillage':'maquillaje','makillaje':'maquillaje','makiyaje':'maquillaje',
    'labiales':'labial','lipstik':'lipstick',
    'serun':'serum','suero':'serum',
    'protector':'protector solar','blokeador':'bloqueador','bloquedor':'bloqueador',
    'sapatilla':'zapatilla','sapatillas':'zapatillas','zapatiya':'zapatilla','zapatiyass':'zapatillas',
    'tenis':'zapatillas','sneaker':'sneakers','sniker':'sneakers','snikers':'sneakers',
    'sandalias':'sandalia','chancletas':'sandalia',
    'kartera':'cartera','bolzo':'bolso','mochla':'mochila','mokila':'mochila',
    'lente':'lentes','gafa':'gafas','anteoho':'anteojos',
    'kasakas':'casacas','kasaca':'casaca','chaketa':'chaqueta','chamara':'chamarra',
    'pantalones':'pantalon','jins':'jeans','yins':'jeans',
    /* ── Hogar / cocina ── */
    'likuadora':'licuadora','licuadra':'licuadora','batidra':'batidora',
    'aspiradra':'aspiradora','aspiradra':'aspiradora',
    'cafetera':'cafetera','kaftera':'cafetera',
    'olla':'olla','sarten':'sarten',
    /* ── Juguetes / niños ── */
    'juguete':'juguete','jugete':'juguete','huguete':'juguete',
    'legos':'lego','leggo':'lego',
    'barbi':'barbie','varbie':'barbie',
    'munieca':'muneca','muñeka':'muneca',
    /* ── Suplementos ── */
    'bitamina':'vitamina','vitamnas':'vitamina','bitaminas':'vitamina',
    'proteinas':'proteina','protena':'proteina','protenina':'proteina',
    'colagno':'colageno','kolageno':'colageno',
    'suplemento':'suplemento','suplemnto':'suplemento',
    /* ── Accesorios tech ── */
    'funda':'funda','carkasa':'carcasa','karcasa':'carcasa',
    'maus':'mouse','raton':'mouse',
    'teklado':'teclado','tecldo':'teclado',
    'inpresora':'impresora','impresra':'impresora',
    'pendraiv':'pendrive','usb':'usb','memoria':'memoria usb',
    'monitr':'monitor','pantaya':'pantalla',
    'ruter':'router','modem':'router','ruteador':'router',
    /* ── Marcas del catálogo UnaLuka ── */
    'owala':'owala','obala':'owala','ouala':'owala','owalla':'owala',
    'stanly':'stanley','estanley':'stanley','estanly':'stanley','stanli':'stanley',
    'dyzon':'dyson','daison':'dyson','dayson':'dyson',
    'funco':'funko','funco':'funko','funqo':'funko',
    'karhart':'carhartt','carheart':'carhartt','carhart':'carhartt',
    'timberlan':'timberland','timberlad':'timberland','timberlan':'timberland',
    'columbia':'columbia','kolumbia':'columbia',
    'lacoste':'lacoste','lakost':'lacoste','lacost':'lacoste',
    'ralfloren':'ralph lauren','ralf lauren':'ralph lauren','ralphloren':'ralph lauren',
    'kalvin':'calvin klein','calvin klain':'calvin klein','kelvin klein':'calvin klein',
    'tomy':'tommy hilfiger','tomi':'tommy hilfiger','tomy hilfiger':'tommy hilfiger',
    'versache':'versace','bersace':'versace','bersache':'versace',
    'guchi':'gucci','guchi':'gucci','gusi':'gucci',
    'dyor':'dior','deor':'dior',
    'givenshy':'givenchy','givenshi':'givenchy','yivenchi':'givenchy',
    'ermez':'hermes','ermes':'hermes','herms':'hermes',
    'burberri':'burberry','barberi':'burberry','burberi':'burberry',
    'anquer':'anker','anqer':'anker',
    'goprou':'gopro','go pro':'gopro',
    'diji':'dji','deji':'dji',
    'garmi':'garmin','garming':'garmin',
    'fosil':'fossil','focil':'fossil',
    'kasio':'casio','cassio':'casio',
    'invikta':'invicta','imbicta':'invicta',
    'rayban':'ray-ban','rei ban':'ray-ban','reiban':'ray-ban',
    'oakli':'oakley','oaklei':'oakley',
    'sol de janero':'sol de janeiro','sol janeiro':'sol de janeiro',
    'clinike':'clinique','cliniqu':'clinique',
    'estilauder':'estee lauder','este lauder':'estee lauder',
    'charlot tilbury':'charlotte tilbury','charlotte tilburi':'charlotte tilbury',
    'fenti':'fenty beauty','fenty beuty':'fenty beauty',
    'tarte':'tarte','tart':'tarte',
    'the ordinari':'the ordinary','ordinary':'the ordinary',
    'playsteishon':'playstation','pleisteision':'playstation','ps5':'playstation',
    'nientendo':'nintendo','nitendo':'nintendo','suich':'switch','swich':'switch',
    'marshol':'marshall','marschal':'marshall',
    'seniheiser':'sennheiser','senhaiser':'sennheiser',
    'yamaja':'yamaha','yamaa':'yamaha',
    'fender':'fender','fender':'fender',
    'corsario':'corsair','korseir':'corsair',
    'redragon':'redragon','reddragon':'redragon',
    'raiser':'razer','reiser':'razer',
    'intel':'intel','intal':'intel',
    'msi':'msi',
    'asus':'asus','azus':'asus',
    'canon':'canon','kanon':'canon',
    'fuji':'fujifilm','fujifilm':'fujifilm',
    'filips':'philips','phillips':'philips','philps':'philips',
    'beats':'beats','bits':'beats',
    'sonos':'sonos','sonus':'sonos',
    'shoks':'shokz','shokz':'shokz',
    'lego':'lego','leggo':'lego',
    'jotweels':'hot wheels','jotwils':'hot wheels',
    'hasbro':'hasbro','hazbro':'hasbro',
    'mattel':'mattel','matel':'mattel',
    'popmart':'pop mart','pop mar':'pop mart',
    'bandai':'bandai','vandai':'bandai'
  };

  /* ── Helpers ── */
  function norm(str) {
    if (!str) return '';
    return str.toLowerCase().replace(/[áàâã]/g,'a').replace(/[éèê]/g,'e')
      .replace(/[íìî]/g,'i').replace(/[óòôõ]/g,'o').replace(/[úùû]/g,'u')
      .replace(/ñ/g,'n').trim();
  }

  /* Corrección fonética: reemplaza cada palabra por su versión correcta si existe */
  function phoneticFix(query) {
    var words = norm(query).split(/\s+/);
    var changed = false;
    for (var i = 0; i < words.length; i++) {
      if (PHONETIC[words[i]]) {
        words[i] = PHONETIC[words[i]];
        changed = true;
      }
    }
    return changed ? words.join(' ') : query;
  }

  function getSyns(query) {
    var words = norm(query).split(/\s+/), syns = [];
    for (var i = 0; i < words.length; i++) {
      var s = SYNONYMS[words[i]];
      if (s) for (var j = 0; j < s.length; j++) { if (syns.indexOf(s[j]) === -1) syns.push(s[j]); }
    }
    return syns;
  }

  /* ── Boosting ── */
  function score(query, p) {
    var s = 0, q = norm(query), qw = q.split(/\s+/);
    var title = norm(p.title), ptype = norm(p.product_type || ''), vendor = norm(p.vendor || '');
    var titleWords = title.split(/\s+/);

    /* Title (0-100) */
    if (title === q) s += 100;
    else if (title.indexOf(q) === 0) s += 90;
    else {
      /* Palabra del título empieza con el query → producto principal */
      var firstWordMatch = false;
      for (var w = 0; w < titleWords.length && w < 3; w++) {
        if (titleWords[w].indexOf(q) === 0) { firstWordMatch = true; break; }
      }
      if (firstWordMatch) s += 80;
      else if (title.indexOf(q) !== -1) s += 55;
      else {
        var wm = 0;
        for (var i = 0; i < qw.length; i++) { if (title.indexOf(qw[i]) !== -1) wm++; }
        s += (wm === qw.length) ? 45 : Math.round((wm / qw.length) * 30);
      }
    }

    /* Penalizar accesorios: si el query aparece tarde en el título (posición 3+) */
    var qPos = -1;
    for (var wp = 0; wp < titleWords.length; wp++) {
      if (titleWords[wp].indexOf(q) !== -1) { qPos = wp; break; }
    }
    if (qPos >= 3) s -= 15;

    /* Product type (0-20) */
    if (ptype && ptype.indexOf(q) !== -1) s += 20;
    else if (ptype) {
      for (var j = 0; j < qw.length; j++) { if (ptype.indexOf(qw[j]) !== -1) { s += 10; break; } }
    }

    /* Vendor (0-15) */
    if (vendor && (vendor === q || vendor.indexOf(q) !== -1)) s += 15;

    if (!p.available) s -= 30;
    if (p.has_compare_price) s += 5;
    return s;
  }

  /* ── Predictive Search API ── */
  function fetchPredictive(query, callback) {
    fetchWithQueries(query, callback);
  }

  /* ── Legacy fallback ── */
  function fetchLegacy(query) {
    var d = $.Deferred();
    $.ajax({
      url: '/search', data: { q: '*' + query + '*', type: 'product', view: 'json' },
      dataType: 'json', timeout: API_TIMEOUT,
      success: function(data) {
        var products = [];
        if (data && data.length) {
          for (var i = 0; i < data.length; i++) {
            var p = data[i];
            products.push({
              title: p.title, handle: p.handle, featured_image: p.featured_image,
              available: p.available, price: p.price, compare_price: p.compare_price,
              has_compare_price: !!p.has_compare_price,
              product_type: p.product_type || '', vendor: p.vendor || '',
              tags: p.tags || [], _src: 'leg'
            });
          }
        }
        d.resolve(products);
      },
      error: function() { d.resolve([]); }
    });
    return d.promise();
  }

  /* ── Pipeline ── */
  function smartSearch(query, cb) {
    fetchPredictive(query).then(function(results) {
      /* Pocos resultados → buscar con sinónimo */
      if (results.length < 3) {
        var syns = getSyns(query);
        if (syns.length > 0) {
          fetchPredictive(syns[0]).then(function(extra) {
            cb(rank(query, merge(results, extra)));
          });
          return;
        }
      }
      cb(rank(query, results));
    }, function() {
      /* Fallback */
      fetchLegacy(query).then(function(r) { cb(rank(query, r)); });
    });
  }

  function merge(a, b) {
    var seen = {}, m = [];
    var all = a.concat(b);
    for (var i = 0; i < all.length; i++) {
      var k = (all[i].handle || all[i].title).split('?')[0];
      if (!seen[k]) { seen[k] = true; m.push(all[i]); }
    }
    return m;
  }

  function rank(query, products) {
    for (var i = 0; i < products.length; i++) products[i]._score = score(query, products[i]);
    products.sort(function(a, b) { return b._score - a._score; });
    return products.slice(0, MAX_RESULTS);
  }

  /* ── Fetch con queries (sugerencias de texto) ── */
  var lastQueries = [];
  var lastCollections = [];
  function fetchWithQueries(query, cb) {
    $.ajax({
      url: '/search/suggest.json',
      data: { q: query, 'resources[type]': 'product,query,collection', 'resources[limit]': MAX_RESULTS,
        'resources[options][fields]': 'title,product_type,vendor,tag,body' },
      dataType: 'json', timeout: API_TIMEOUT,
      success: function(data) {
        try {
          lastQueries = (data.resources.results.queries || []).slice(0, 5);
        } catch(e) { lastQueries = []; }
        try {
          lastCollections = (data.resources.results.collections || []).slice(0, 4);
        } catch(e) { lastCollections = []; }
        var products = [];
        try {
          var raw = data.resources.results.products || [];
          for (var i = 0; i < raw.length; i++) {
            var p = raw[i];
            /* Ocultar productos 'cotizado', EXCEPTO los que son deal (tag 'deal'/'deals'/'deal producto') */
            if (p.tags && p.tags.indexOf('cotizado') !== -1) {
              var isDeal = false;
              for (var ti = 0; ti < p.tags.length; ti++) {
                if ((p.tags[ti] || '').toLowerCase().indexOf('deal') === 0) { isDeal = true; break; }
              }
              if (!isDeal) continue;
            }
            var prc = parseFloat(p.price_min || p.price || '0');
            var cmp = parseFloat(p.compare_at_price_max || p.compare_at_price_min || '0');
            var hasCmp = cmp > 0 && cmp > prc;
            var imgUrl = (p.featured_image && p.featured_image.url) || p.image || '';
            products.push({
              title: p.title, handle: p.url, featured_image: imgUrl,
              available: p.available,
              price: 'S/' + Math.round(prc),
              compare_price: hasCmp ? 'S/' + Math.round(cmp) : '',
              has_compare_price: hasCmp,
              product_type: p.type || '', vendor: p.vendor || '',
              tags: p.tags || [], _src: 'pred'
            });
          }
        } catch (e) {}
        cb(products);
      },
      error: function() { lastQueries = []; lastCollections = []; cb(null); }
    });
  }

  /* ── Generar sugerencias desde productos YA rankeados ── */
  function buildSuggestions(query, ranked) {
    if (lastQueries.length > 0 || ranked.length === 0) return;
    var seen = {}, qNorm = norm(query);

    /* A. Sugerencias de texto desde títulos (3-4) */
    for (var t = 0; t < ranked.length && lastQueries.length < 4; t++) {
      var words = ranked[t].title.split(/\s+/);
      var startIdx = 0;
      for (var wi = 0; wi < words.length; wi++) {
        if (norm(words[wi]).indexOf(qNorm) === 0) { startIdx = wi; break; }
      }
      var suggestion = words.slice(startIdx, startIdx + 4).join(' ')
        .replace(/\s*[\(\[\{].*$/, '').replace(/[,;]+$/, '').trim();
      var sKey = norm(suggestion);
      if (sKey && sKey !== qNorm && !seen[sKey]) {
        seen[sKey] = true;
        lastQueries.push({ text: suggestion });
      }
    }

    /* B. Sugerencias con categoría: "query en Categoría" (1-2) */
    var catSeen = {};
    for (var c = 0; c < ranked.length && lastQueries.length < 6; c++) {
      var cat = ranked[c].product_type;
      if (cat && !catSeen[cat]) {
        catSeen[cat] = true;
        lastQueries.push({ text: query, category: cat });
      }
    }
  }

  /* ── Smart search con queries ── */
  function smartSearch(query, cb) {
    /* Corrección fonética antes de buscar */
    var apiQuery = phoneticFix(query);
    fetchWithQueries(apiQuery, function(results) {
      if (results === null) {
        fetchLegacy(apiQuery).then(function(r) {
          var ranked = rank(apiQuery, r);
          buildSuggestions(apiQuery, ranked);
          cb(ranked);
        });
        return;
      }

      /* Casi sin resultados → intentar con primer sinónimo */
      if (results.length < 2) {
        var syns = getSyns(apiQuery);
        if (syns.length > 0) {
          fetchWithQueries(syns[0], function(extra) {
            var merged = rank(apiQuery, merge(results, extra || []));
            buildSuggestions(apiQuery, merged);
            cb(merged);
          });
          return;
        }
      }

      var ranked = rank(apiQuery, results);
      buildSuggestions(apiQuery, ranked);
      cb(ranked);
    });
  }

  /* ── Rendering — Amazon/MeLi style ── */
  function renderResults(keyword, products, resultElement) {
    var html = '';
    var esc = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    /* Bold en la palabra completa que contiene el query, no solo las letras exactas */
    var boldWordRe = new RegExp('(\\S*' + esc + '\\S*)', 'gi');

    /* 1. Colecciones como sugerencias (solo si top producto no es buen match) */
    var topScore = products.length > 0 ? (products[0]._score || 0) : 0;
    if (lastCollections.length > 0 && topScore < 70) {
      for (var ci = 0; ci < lastCollections.length; ci++) {
        var col = lastCollections[ci];
        var colUrl = (col.url || '').split('?')[0];
        var colTitle = (col.title || '').replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu, '').trim();
        if (!colTitle) continue;
        html += '<li class="sr-query"><a href="' + colUrl + '">'
          + '<svg class="sr-qicon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
          + colTitle + '</a></li>';
      }
    }

    /* 2. Text suggestions */
    if (lastQueries.length > 0) {
      for (var q = 0; q < lastQueries.length; q++) {
        var qText = lastQueries[q].text || lastQueries[q];
        var qCat = lastQueries[q].category || '';
        var qStyled = String(qText).replace(boldWordRe, '<strong>$1</strong>');
        var catHtml = qCat ? ' <span class="sr-cat">en ' + qCat + '</span>' : '';
        html += '<li class="sr-query"><a href="/search?type=product&q=' + encodeURIComponent(qText) + '">'
          + '<svg class="sr-qicon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
          + qStyled + catHtml + '</a></li>';
      }
    }

    /* 2. Products */
    var maxProducts = 10;
    if (products.length > 0) {
      for (var i = 0; i < products.length && i < maxProducts; i++) {
        var item = products[i];
        var handle = item.handle;
        var image = item.featured_image || '';
        var markedTitle = item.title.replace(boldWordRe, '<span class="sr-mark">$1</span>');

        var priceHtml = '';
        if (item.available) {
          if (item.has_compare_price && item.compare_price) {
            priceHtml = '<span class="sr-now">' + item.price + '</span>'
              + '<span class="sr-was">' + item.compare_price + '</span>';
          } else {
            priceHtml = '<span class="sr-now">' + item.price + '</span>';
          }
        } else {
          priceHtml = '<span class="sr-oos">Agotado</span>';
        }

        html += '<li class="result-item">'
          + '<a href="' + handle + '" class="sr-link">'
          + '<div class="sr-img"><img src="' + image + '" alt="" loading="lazy"></div>'
          + '<div class="sr-mid">'
          + '<span class="sr-title">' + markedTitle + '</span>'
          + '</div>'
          + '<div class="sr-right">' + priceHtml + '</div>'
          + '</a></li>';
      }
    }

    if (html === '') {
      html = '<li class="sr-empty">'
        + '<div class="sr-empty-inner">'
        + '<div class="sr-empty-icon"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></div>'
        + '<div class="sr-empty-title">No encontramos resultados para "<strong>' + keyword + '</strong>"</div>'
        + '<div class="sr-empty-tips">Intenta con otro término, revisa la ortografía o busca por categoría.</div>'
        + '</div></li>';
    }

    resultElement.html(html);
    $('.result-ajax-search').show();

    
  }

  /* ── Search History ── */
  var HISTORY_KEY = 'ulk_search_history';
  var HISTORY_MAX = 8;

  function getHistory() {
    try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch(e) { return []; }
  }
  function saveToHistory(query) {
    var q = query.trim();
    if (!q || q.length < 2) return;
    var h = getHistory().filter(function(item) { return norm(item) !== norm(q); });
    h.unshift(q);
    if (h.length > HISTORY_MAX) h = h.slice(0, HISTORY_MAX);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(h));
  }
  function removeFromHistory(idx) {
    var h = getHistory();
    h.splice(idx, 1);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(h));
  }
  function clearHistory() {
    localStorage.removeItem(HISTORY_KEY);
  }

  var clockIco = '<svg class="sr-qicon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
  var removeIco = '<svg class="sr-history-x" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

  function renderHistory(resultElement) {
    var h = getHistory();
    if (h.length === 0) return false;
    var html = '';
    for (var i = 0; i < h.length; i++) {
      html += '<li class="sr-query sr-history-item">'
        + '<a href="/search?type=product&q=' + encodeURIComponent(h[i]) + '" data-history="1">'
        + clockIco + h[i] + '</a>'
        + '<button class="sr-history-remove" data-idx="' + i + '">' + removeIco + '</button></li>';
    }
    html += '<li class="sr-history-footer"><button class="sr-history-clear">Borrar historial</button></li>';
    resultElement.html(html);
    $('.result-ajax-search').show();

    /* Bind remove/clear */
    resultElement.find('.sr-history-remove').on('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      removeFromHistory(parseInt($(this).data('idx')));
      renderHistory(resultElement);
    });
    resultElement.find('.sr-history-clear').on('click', function(e) {
      e.preventDefault(); e.stopPropagation();
      clearHistory();
      $('.result-ajax-search').hide();
    });
    return true;
  }

  /* ── CSS ── */
  (function() {
    var css = ''
      + '.result-ajax-search .search-results{list-style:none;margin:0;padding:0}'

      /* Override tema base Electro — eliminar fondo gris hover y padding extra */
      + '.result-ajax-search ul li{padding:0 !important;background:transparent !important}'
      + '.result-ajax-search ul li:hover{background:transparent !important}'

      /* Query suggestions */
      + '.sr-query a{display:flex;align-items:center;gap:8px;padding:10px 16px;font-size:16px;color:#333;text-decoration:none}'
      + '.sr-query a:hover{background:#f5f5f5;color:#111}'

      /* History — Amazon style */
      + '.sr-history-item{position:relative}'
      + '.sr-history-item a{flex:1;padding-right:36px !important;font-size:15px}'
      + '.sr-history-remove{position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;padding:6px}'
      + '.sr-history-remove:hover svg{stroke:#666}'
      + '.sr-history-footer{border-top:1px solid #f0f0f0;padding:0 !important}'
      + '.sr-history-clear{display:block;width:100%;background:none;border:none;color:#999;font-size:13px;cursor:pointer;padding:10px 16px;text-align:left}'
      + '.sr-history-clear:hover{color:#dc2626;background:#fafafa}'
      + '.sr-query strong{font-weight:800;color:#111}'
      + '.sr-qicon{flex-shrink:0}'
      + '.sr-cat{color:#999;font-style:italic;font-weight:400}'


      /* Product items */
      + '.result-item{}'
      + '.sr-link{display:flex;align-items:center;gap:10px;padding:12px 16px;text-decoration:none;color:inherit}'
      + '.sr-link:hover{background:#f5f5f5;text-decoration:none;color:inherit}'

      /* Image */
      + '.sr-img{flex:0 0 80px;width:80px;height:80px;overflow:hidden;background:#fff}'
      + '.sr-img img{width:100%;height:100%;object-fit:contain}'

      /* Middle: title */
      + '.sr-mid{flex:1;min-width:0}'
      + '.sr-title{font-size:16px;font-weight:500;color:#333;line-height:1.35;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden}'
      + '.sr-mark{font-weight:700;color:#111}'

      /* Right: prices */
      + '.sr-right{flex-shrink:0;text-align:right;display:flex;flex-direction:column;align-items:flex-end;gap:0}'
      + '.sr-now{font-size:17px;font-weight:900;color:#dc2626;white-space:nowrap}'
      + '.sr-was{font-size:13px;color:#aaa;text-decoration:line-through;white-space:nowrap}'
      + '.sr-oos{font-size:14px;color:#999}'

      /* Empty */
      + '.sr-empty{padding:0 !important;background:transparent !important}'
      + '.sr-empty-inner{padding:48px 20px;text-align:center}'
      + '.sr-empty-icon{margin-bottom:12px}'
      + '.sr-empty-title{font-size:15px;color:#333;font-weight:600;margin-bottom:6px}'
      + '.sr-empty-title strong{color:#111}'
      + '.sr-empty-tips{font-size:13px;color:#999;line-height:1.4}'

      /* Mobile */
      + '@media(max-width:991px){'
      + '.sr-img{flex:0 0 68px;width:68px;height:68px}'
      + '.sr-title{font-size:14px}'
      + '.sr-now{font-size:14px}'
      + '.sr-was{font-size:12px}'
      + '.sr-query a{font-size:14px;padding:8px 16px}'
      + '}';
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  })();

  /* ── Events — igual que el original + historial ── */
  function init(config) {
    var inputSelector = config.search_input || '.bc-product-search';
    var wrapperSelector = config.result_wrapper || '.result-ajax-search';
    var resultSelector = config.result_element || '.search-results';
    var debounceTimer;
    var blurTimer;

    /* Show history on focus when input is empty */
    $(document).delegate(inputSelector, 'focus click', function() {
      if (blurTimer) { clearTimeout(blurTimer); blurTimer = null; }
      var keyword = $(this).val().trim();
      if (keyword.length < MIN_CHARS) {
        var resultElement = $(wrapperSelector).children(resultSelector);
        renderHistory(resultElement);
      }
    });

    $(document).delegate(inputSelector, 'keyup', function(e) {
      var keyword = $(this).val();
      var searchEl = $(this);
      var resultWrapper = $(wrapperSelector);
      var resultElement = resultWrapper.children(resultSelector);

      /* Enter → save to history */
      if (e.keyCode === 13 && keyword.trim().length >= MIN_CHARS) {
        saveToHistory(phoneticFix(keyword));
      }

      if (debounceTimer) clearTimeout(debounceTimer);

      debounceTimer = setTimeout(function() {
        if (keyword.length < MIN_CHARS) {
          /* Show history instead of hiding */
          if (!renderHistory(resultElement)) {
            $(wrapperSelector).hide();
          }
        } else {
          $(searchEl).removeClass('error warning valid').addClass('valid');
          $('.searchbox, .searchbox-mobile').addClass('s-loading');

          lastSearchQuery = keyword;
          smartSearch(keyword, function(results) {
            $('.searchbox, .searchbox-mobile').removeClass('s-loading');
            renderResults(phoneticFix(keyword), results, resultElement);
          });
        }
      }, DEBOUNCE_MS);
    });

    /* Save to history when clicking a product result or suggestion */
    var lastSearchQuery = '';
    $(document).delegate(wrapperSelector + ' .result-item a, ' + wrapperSelector + ' .sr-query a:not([data-history])', 'mousedown', function() {
      var q = lastSearchQuery || $(inputSelector).filter(':visible').val() || '';
      if (q.trim().length >= MIN_CHARS) saveToHistory(phoneticFix(q));
    });

    $(document).delegate(inputSelector, 'blur', function() {
      blurTimer = setTimeout(function() { $(wrapperSelector).hide(); }, 200);
    });
  }

  return { init: init, ajaxSearch: function() {}, ajaxProductItems: function() {} };
})(jQuery);

jQuery(document).ready(function($) {
  AT_AjaxSearch.init({
    search_input: '.bc-product-search',
    result_wrapper: '.result-ajax-search',
    result_element: '.search-results',
    strictly_mode: 0
  });
});
